class ForgottenPasswordController {
    /*@ngInject*/
    constructor($log, $http, $httpParamSerializerJQLike, CommonService) {
        this.requestPending = false;
        this.$log = $log;
        this.$http = $http;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.CommonService = CommonService;
        this.email = '';
    }

    preventSubmit(evt) {
        evt.preventDefault();
    }

    // https://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-without-jquery
    submit(form) {
        let url = this.CommonService.getBaseUrl() + '/login/pw/request';
        this.requestPending = true;
        // use this if the CSRFToken from the form is needed
        // $(form.$$element).find('[name="CSRFToken"]')[0].value
        let req = {
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: this.$httpParamSerializerJQLike({
                email: this.email
            })
        };

        // https://stackoverflow.com/questions/24545072/angularjs-http-post-send-data-as-json
        this.$http(req).then((response) => {
            // check if the answer is correct
            if ($(response.data).find('#alert__password-forgotten').length) {
                this.email = '';
                $('.page-main').prepend(response.data);
                $('html, body').scrollTop(0);
            } else {
                // maybe not the best way for the error handling :-)
                window.location.reload(true);
            }
        }, (error) => {
            this.$log.error('request new password request error: ' + error.status + ' ' + error.statusText);
        }).finally(() => {
            this.requestPending = false;
            $('#modal__password-forgotten').modal('hide');
        });
    }
}

export default ForgottenPasswordController;
